export default "/images/vendor/quill/icons/float-full.svg?928ea0b8deb9e17786f2bbcd77324de2";